import { skipToken } from "@reduxjs/toolkit/query";
import { useGetDocumentsByUserIdQuery } from "../api/documents";
import { useGetCurrentUserQuery } from "../api/users";

const useGetCurrentUserDocument = () => {
  const {
    data: user,
    isLoading: isUserLoading,
    error: userError,
  } = useGetCurrentUserQuery();
  const {
    data: documents,
    isLoading: isDocumentsLoading,
    error: documentsError,
  } = useGetDocumentsByUserIdQuery(user?.id ?? skipToken, {
    refetchOnMountOrArgChange: true,
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });
  const document = documents ? documents[0] : null;

  const error = userError ?? documentsError;

  return {
    document,
    user,
    isLoading: isUserLoading || isDocumentsLoading,
    error,
  };
};

export default useGetCurrentUserDocument;
